import React from 'react';
import { Typography, Box, makeStyles } from '@material-ui/core';
import CustomButton from '../common/customButton';
import ReactPlayer from 'react-player';
import useReactRouter from 'use-react-router';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { getPostLanguage } from '../../services/authService';
import languages from '../../utils/languages';
import { useStoreState } from 'easy-peasy';
import { useTablet } from '../../hooks/utilHooks';
import { useWomenWillVideo } from '../../hooks/lectureHook';

const WomenWillVideo = ({ post, handleClickAskQuestion }) => {
  const isTablet = useTablet();
  const webLanguage = getPostLanguage();
  const languageText = languages[webLanguage ? webLanguage : 'en'];
  const classes = useStyles();
  const { history } = useReactRouter();
  const fromButton = history?.location?.state?.fromButton;
  fromButton && handleClickAskQuestion();
  let lectureData = useStoreState((state) => state.lecture.lectureData);

  const {
    playerRef,
    onProgressStatus,
    handleSeek,
    onReady,
    config,
    lectureId,
    onEnded,
    handleClick,
    disabled,
    showCTAButton,
  } = useWomenWillVideo({ lectureData, post });

  return (
    <React.Fragment>
      <Box mt={-2}>
        <ReactPlayer
          ref={playerRef}
          playing={false}
          loop={false}
          controls={true}
          url={lectureData && lectureData.video.sourceVideoUrl}
          width="100%"
          height="auto"
          onProgress={(e) => onProgressStatus(e)}
          onSeek={(e) => handleSeek(e)}
          onReady={onReady}
          config={config}
          onEnded={() => onEnded(lectureId)}
        />

        <Box py={4} px={4}>
          {lectureData && lectureData.description && (
            <Box display="flex" alignItems="center">
              <FiberManualRecordIcon className={classes.dotIcon} />
              <Typography variant="body1" className={classes.videoDes}>
                {lectureData && lectureData.description}
              </Typography>
            </Box>
          )}
          {showCTAButton && (
            <Box my={4} justifyContent="space-between" display="flex">
              <CustomButton
                onClick={handleClickAskQuestion}
                variant="outlined"
                text={languageText?.ASK_QUESTION}
                size="regular"
                className={
                  isTablet
                    ? `${classes.mobileBtnWidth} ${classes.btnOutlined}`
                    : classes.btnOutlined
                }
              ></CustomButton>

              <CustomButton
                variant="primary"
                text={
                  lectureData && lectureData.quiz && lectureData.quiz[0]
                    ? languageText?.TAKE_ASSIGNMENT
                    : languageText?.NEXT_VIDEO
                }
                size="regular"
                className={
                  isTablet
                    ? `${classes.mobileBtnWidth} ${classes.btn}`
                    : classes.btn
                }
                onClick={() => handleClick()}
                disabled={disabled}
              ></CustomButton>
            </Box>
          )}
        </Box>
      </Box>
    </React.Fragment>
  );
};

const useStyles = makeStyles((theme) => ({
  btnOutlined: {
    minWidth: '167px',
    borderRadius: theme.spacing(6.5),
    color: '#019d53',
    border: '1px solid #019d53',
    '&:hover': {
      color: '#fff',
      boxShadow: 'none',
      border: 'none',
      backgroundColor: '#019d53',
    },
  },
  btn: {
    minWidth: '167px',
    backgroundColor: '#019d53',
    borderRadius: theme.spacing(6.5),
    '&:hover': {
      backgroundColor: '#019d53',
    },
  },
  mobileBtnWidth: {
    minWidth: '140px',
  },
  dotIcon: {
    color: '#747171',
    margin: theme.spacing(0, 1, 0, 0),
    fontSize: '12px',
  },
}));
export default WomenWillVideo;
